import { render } from "./ListUserPage.vue?vue&type=template&id=3d25dac4"
import script from "./ListUserPage.vue?vue&type=script&lang=js"
export * from "./ListUserPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__